import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};

// =============================================
// DATA 4 AKUN SHOPEE — ganti sesuai kebutuhan
// =============================================
const shopeeAccounts = [
  {
    label: "Cabang Bogor",
    desc: "Akun Shopee Bogor",
    url: "https://id.shp.ee/ySzaV8Wg",
  },
  {
    label: "Cabang Siduarjo",
    desc: "Akun Shopee Siduarjo",
    url: "https://shopee.co.id/corebuild_solution_ii?entryPoint=ShopBySearch&searchKeyword=corebuild%20solution",
  },
  {
    label: "Cabang Jogja",
    desc: "Akun Shopee Jogja",
    url: "https://shopee.co.id/placeholder3",
  },
  {
    label: "Toko Cabang 3",
    desc: "Akun Shopee 4",
    url: "https://shopee.co.id/placeholder4",
  },
];

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [status, setStatus] = useState(null);
  const [shopeeOpen, setShopeeOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("loading");
    emailjs
      .sendForm("corebuildsolution", "corebuildsolu", e.target, "-0-2Hgtn4EXPQAQNI")
      .then(
        (result) => {
          console.log(result.text);
          clearState();
          setStatus("success");
          setTimeout(() => setStatus(null), 5000);
        },
        (error) => {
          console.log(error.text);
          setStatus("error");
          setTimeout(() => setStatus(null), 5000);
        }
      );
  };

  return (
    <>
      <style>{`
        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-10px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes popupIn {
          from { opacity: 0; transform: translateY(10px) scale(0.97); }
          to   { opacity: 1; transform: translateY(0) scale(1); }
        }

        #contact {
          overflow-x: hidden;
          width: 100%;
          box-sizing: border-box;
        }
        #contact .container,
        #footer .container {
          width: 100%;
          max-width: 1170px;
          margin: 0 auto;
          padding: 0 15px;
          box-sizing: border-box;
        }
        .contact-wrapper {
          display: flex;
          flex-wrap: wrap;
          gap: 0;
          box-sizing: border-box;
          width: 100%;
        }
        .contact-form-col {
          width: 100%;
          box-sizing: border-box;
          padding-right: 0;
        }
        .contact-info-col {
          width: 100%;
          box-sizing: border-box;
          margin-top: 24px;
        }
        .contact-social-col {
          width: 100%;
          box-sizing: border-box;
          margin-top: 16px;
        }
        #contact input,
        #contact textarea {
          width: 100%;
          box-sizing: border-box;
          max-width: 100%;
        }
        .contact-form-row {
          display: flex;
          flex-wrap: wrap;
          gap: 0;
          box-sizing: border-box;
        }
        .contact-input-half {
          width: 100%;
          box-sizing: border-box;
          padding-right: 0;
        }
        #footer {
          overflow-x: hidden;
          width: 100%;
          box-sizing: border-box;
        }
        .social ul {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 10px;
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .marketplace-label {
          text-align: center;
          margin-top: 20px;
          margin-bottom: 10px;
          color: rgba(255,255,255,0.7);
          font-size: 12px;
          letter-spacing: 1px;
          text-transform: uppercase;
        }
        .marketplace-links {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 14px;
          align-items: center;
          box-sizing: border-box;
        }
        .marketplace-links a,
        .marketplace-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: rgba(255,255,255,0.15);
          border: 1px solid rgba(255,255,255,0.3);
          transition: background 0.2s ease, transform 0.2s ease;
          text-decoration: none;
          box-sizing: border-box;
          cursor: pointer;
        }
        .marketplace-links a:hover,
        .marketplace-btn:hover {
          background: rgba(255,255,255,0.3);
          transform: scale(1.1);
          text-decoration: none;
        }
        .marketplace-links img,
        .marketplace-btn img {
          width: 26px;
          height: 26px;
          object-fit: contain;
          display: block;
          border-radius: 6px;
        }

        /* ===== SHOPEE POPUP OVERLAY ===== */
        .shopee-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.55);
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 16px;
        }
        .shopee-popup {
          background: #fff;
          border-radius: 16px;
          padding: 28px 24px 24px;
          width: 100%;
          max-width: 380px;
          box-shadow: 0 20px 60px rgba(0,0,0,0.25);
          animation: popupIn 0.25s ease;
          position: relative;
        }
        .shopee-popup-header {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 20px;
        }
        .shopee-popup-header img {
          width: 32px;
          height: 32px;
          object-fit: contain;
          border-radius: 6px;
        }
        .shopee-popup-header h4 {
          margin: 0;
          font-size: 16px;
          font-weight: 700;
          color: #ee4d2d;
        }
        .shopee-popup-close {
          position: absolute;
          top: 14px;
          right: 16px;
          background: none;
          border: none;
          font-size: 22px;
          color: #888;
          cursor: pointer;
          line-height: 1;
          padding: 0;
        }
        .shopee-popup-close:hover {
          color: #333;
        }
        .shopee-account-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        .shopee-account-item {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 12px 14px;
          border-radius: 12px;
          border: 1.5px solid #f0e0dc;
          background: #fff8f7;
          text-decoration: none;
          transition: background 0.18s, border-color 0.18s, transform 0.18s;
        }
        .shopee-account-item:hover {
          background: #fff0ed;
          border-color: #ee4d2d;
          transform: translateX(4px);
          text-decoration: none;
        }
        .shopee-account-item img {
          width: 36px;
          height: 36px;
          object-fit: contain;
          border-radius: 8px;
          flex-shrink: 0;
        }
        .shopee-account-info {
          display: flex;
          flex-direction: column;
        }
        .shopee-account-label {
          font-size: 14px;
          font-weight: 700;
          color: #333;
          margin: 0;
          line-height: 1.3;
        }
        .shopee-account-desc {
          font-size: 12px;
          color: #999;
          margin: 2px 0 0;
        }
        .shopee-account-arrow {
          margin-left: auto;
          color: #ee4d2d;
          font-size: 18px;
          flex-shrink: 0;
        }

        @media (min-width: 992px) {
          .contact-form-col {
            width: 66.6666%;
            padding-right: 30px;
          }
          .contact-info-col {
            width: 25%;
            margin-left: 8.3333%;
            margin-top: 0;
          }
          .contact-input-half {
            width: 50%;
            padding-right: 15px;
          }
          .contact-input-half:last-child {
            padding-right: 0;
            padding-left: 15px;
          }
        }

        @media (max-width: 767px) {
          .contact-form-col,
          .contact-info-col,
          .contact-social-col {
            width: 100%;
            margin-left: 0;
          }
          .contact-input-half {
            width: 100%;
            padding-right: 0;
          }
          .marketplace-links a,
          .marketplace-btn {
            width: 44px;
            height: 44px;
          }
          .marketplace-links img,
          .marketplace-btn img {
            width: 22px;
            height: 22px;
          }
        }
      `}</style>

      <div>
        <div id="contact">
          <div className="container">
            <div className="contact-wrapper">

              {/* Form */}
              <div className="contact-form-col">
                <div className="section-title">
                  <h2>Get In Touch</h2>
                  <p>
                    Please fill out the form below to send us an email and we will
                    get back to you as soon as possible.
                  </p>
                </div>
                <form name="sentMessage" validate onSubmit={handleSubmit}>
                  <div className="contact-form-row">
                    <div className="contact-input-half">
                      <div className="form-group">
                        <input
                          type="text"
                          id="name"
                          name="name"
                          className="form-control"
                          placeholder="Name"
                          required
                          onChange={handleChange}
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                    <div className="contact-input-half">
                      <div className="form-group">
                        <input
                          type="email"
                          id="email"
                          name="email"
                          className="form-control"
                          placeholder="Email"
                          required
                          onChange={handleChange}
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <textarea
                      name="message"
                      id="message"
                      className="form-control"
                      rows="4"
                      placeholder="Message"
                      required
                      onChange={handleChange}
                    ></textarea>
                    <p className="help-block text-danger"></p>
                  </div>
                  <div id="success">
                    {status === "success" && (
                      <div style={{
                        display: "flex", alignItems: "center", gap: "10px",
                        padding: "14px 18px", borderRadius: "10px",
                        background: "#d1fae5", border: "1px solid #6ee7b7",
                        color: "#065f46", fontWeight: 600, fontSize: "14px",
                        marginBottom: "16px", animation: "fadeInDown 0.3s ease",
                      }}>
                        ✅ Pesan berhasil dikirim! Kami akan segera menghubungi kamu.
                      </div>
                    )}
                    {status === "error" && (
                      <div style={{
                        display: "flex", alignItems: "center", gap: "10px",
                        padding: "14px 18px", borderRadius: "10px",
                        background: "#fee2e2", border: "1px solid #fca5a5",
                        color: "#991b1b", fontWeight: 600, fontSize: "14px",
                        marginBottom: "16px", animation: "fadeInDown 0.3s ease",
                      }}>
                        ❌ Gagal mengirim pesan. Coba lagi beberapa saat.
                      </div>
                    )}
                  </div>
                  <button
                    type="submit"
                    className="btn btn-custom btn-lg"
                    disabled={status === "loading"}
                    style={{ opacity: status === "loading" ? 0.7 : 1, cursor: status === "loading" ? "not-allowed" : "pointer" }}
                  >
                    {status === "loading" ? "Mengirim..." : "Send Message"}
                  </button>
                </form>
              </div>

              {/* Info */}
              <div className="contact-info-col contact-info">
                <div className="contact-item">
                  <h3>Contact Info</h3>
                  <p>
                    <span>
                      <i className="fa fa-map-marker"></i> Address
                    </span>
                    {props.data ? props.data.address : "loading"}
                  </p>
                </div>
                <div className="contact-item">
                  <p>
                    <span>
                      <i className="fa fa-phone"></i> Phone
                    </span>{" "}
                    {props.data ? props.data.phone : "loading"}
                  </p>
                </div>
                <div className="contact-item">
                  <p>
                    <span>
                      <i className="fa fa-envelope-o"></i> Email
                    </span>{" "}
                    {props.data ? props.data.email : "loading"}
                  </p>
                </div>
              </div>

              {/* Social + Marketplace */}
              <div className="contact-social-col">
                <p className="marketplace-label">Temukan kami di</p>
                <div className="marketplace-links">

                  {/* Shopee — klik buka popup */}
                  <button
                    className="marketplace-btn"
                    onClick={() => setShopeeOpen(true)}
                    title="Shopee"
                    aria-label="Buka pilihan toko Shopee"
                  >
                    <img src="img/logo/shopee.png" alt="Shopee" />
                  </button>

                  {/* Tokopedia */}
                  <a
                    href={props.data ? props.data.tokopedia : "/"}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Tokopedia"
                  >
                    <img src="img/logo/tokopedianobg.png" alt="Tokopedia" />
                  </a>

                  {/* TikTok */}
                  <a
                    href={props.data ? props.data.tiktok : "/"}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="TikTok"
                  >
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.85 4.85 0 0 1-1.01-.07z"/>
                    </svg>
                  </a>

                </div>
              </div>

            </div>
          </div>
        </div>

        {/* ===== SHOPEE POPUP ===== */}
        {shopeeOpen && (
          <div
            className="shopee-overlay"
            onClick={(e) => { if (e.target === e.currentTarget) setShopeeOpen(false); }}
          >
            <div className="shopee-popup">
              {/* Header */}
              <div className="shopee-popup-header">
                <img src="img/logo/shopee.png" alt="Shopee" />
                <h4>Pilih Toko Shopee</h4>
              </div>

              {/* Tombol tutup */}
              <button
                className="shopee-popup-close"
                onClick={() => setShopeeOpen(false)}
                aria-label="Tutup popup"
              >
                &times;
              </button>

              {/* Daftar akun */}
              <div className="shopee-account-list">
                {shopeeAccounts.map((acc, i) => (
                  <a
                    key={i}
                    href={acc.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="shopee-account-item"
                    onClick={() => setShopeeOpen(false)}
                  >
                    <img src="img/logo/shopee.png" alt="Shopee" />
                    <div className="shopee-account-info">
                      <p className="shopee-account-label">{acc.label}</p>
                      <span className="shopee-account-desc">{acc.desc}</span>
                    </div>
                    <span className="shopee-account-arrow">›</span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        )}

        <div id="footer">
          <div className="container text-center">
            <p>
              &copy; 2026 Muhammad Ardiansyah. Design by{" "}
              <a href="" rel="nofollow">
                //isi
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};